export default function Home() {
  return (
    <div>
      <h1>
        INQUIZ' <br />
        ITOR
      </h1>
    </div>
  );
}
